(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller(
			'supplierWelcomeEmailEditorCustomer',
			supplierWelcomeEmailEditorCustomer
		);

	supplierWelcomeEmailEditorCustomer.$inject = ['$rootScope', '$scope', '$timeout', '$experiments'];

	function supplierWelcomeEmailEditorCustomer($rootScope, $scope, $timeout, $experiments) {
		var vm = this;
	}
})();
